import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormAttachmentUpload from "../../components/formFields/FormAttachmentUpload";
import {
  deleteAttractionsImage,
  getAttractionsByID,
} from "./services/attractions.services";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useLocation } from "react-router-dom";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import IconComponent from "../../components/common/IconComponent";
import { MdImageNotSupported } from "react-icons/md";

const PhotoGalleryArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const AttractionsID = location.state?.AttractionsID;
  const [imageID, setDeleteID] = useState(-1);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.attractions.loading);

  const handleOpenDeleteDialog = (iD: number) => {
    dispatch(openDialog("deleteImageDialog"));
    setDeleteID(iD);
  };

  const handleDeleteImage = async (ID: number) => {
    const res = await dispatch(deleteAttractionsImage(ID));
    if (res.meta.requestStatus === "fulfilled") {
      if (AttractionsID) {
        dispatch(getAttractionsByID(AttractionsID));
      }
      dispatch(closeDialog());
      setDeleteID(-1);
    }
  };
  return (
    <>
      {dialogName === "deleteImageDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Gallery Image"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete Gallery Image?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteImage(imageID)}
                  type="button"
                  disabled={loading}
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      <GridLayout style={{ marginRight: 10 }} gap={{ rows: 10, cols: 10 }}>
        <GridLayoutItem colSpan={2}>
          <Typography.h4>Gallery Photo Upload</Typography.h4>
        </GridLayoutItem>
        <GridLayoutItem>
          <Field
            name={"attachment"}
            label="Upload Images"
            type={"file"}
            accept="image/*"
            multiple={true}
            component={FormAttachmentUpload}
          />
        </GridLayoutItem>
        <GridLayoutItem>
          {(!fieldArrayRenderProps?.value ||
            fieldArrayRenderProps?.value.length === 0) && (
            <div className="text-center" style={{ color: "#6c757d" }}>
              <span className="k-icon k-i-image k-icon-xl mb-2">
                <IconComponent
                  icon={MdImageNotSupported}
                  style={{ fontSize: "24px" }}
                />
              </span>
              <p style={{ color: "#f17272" }} className="mb-0">
                No images uploaded yet
              </p>
            </div>
          )}
        </GridLayoutItem>
        <GridLayoutItem colSpan={2}>
          {fieldArrayRenderProps?.value?.length > 0 && (
            <div className="card shadow-sm border-0 mb-2">
              <div
                className="card-body p-3"
                style={{
                  background: "#f8f9fa",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5
                    className="mb-0"
                    style={{
                      color: "#2c3e50",
                      fontWeight: "600",
                      fontSize: "1.1rem",
                    }}
                  >
                    Uploaded Images
                  </h5>
                  <span className="badge bg-primary rounded-pill">
                    {fieldArrayRenderProps?.value?.length || 0} files
                  </span>
                </div>

                <div className="d-flex flex-wrap gap-3">
                  {fieldArrayRenderProps?.value?.map((image: any) => (
                    <div
                      key={image.ID}
                      className="position-relative"
                      style={{
                        width: "120px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div className="card h-100 border-0 shadow-sm overflow-hidden">
                        <div className="ratio ratio-1x1 bg-light overflow-hidden">
                          <img
                            className="img-fluid object-fit-cover"
                            src={image.Image}
                            alt="Uploaded document"
                            style={{
                              cursor: "pointer",
                              transition: "transform 0.3s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.transform = "scale(1.05)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                            onClick={() =>
                              window.open(`${image.Image}`, "_blank")
                            }
                          />
                        </div>
                        <div className="card-footer p-2 bg-white border-0">
                          <Button
                            className="w-100"
                            size="small"
                            themeColor="error"
                            fillMode="outline"
                            rounded="medium"
                            type="button"
                            style={{
                              border: "1px solid #dc3545",
                              fontWeight: "500",
                            }}
                            onClick={() => handleOpenDeleteDialog(image.ID)}
                          >
                            <span className="k-icon k-i-trash me-1"></span>
                            Delete
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default PhotoGalleryArray;
